import moment from 'moment'

// moment locales for the languages in AVAILABLE_LOCALES, webpack used to bundle all of them. The dist
// versions share the ES module build of moment that vite resolves 'moment' to.
import 'moment/dist/locale/ar'
import 'moment/dist/locale/de'
import 'moment/dist/locale/el'
import 'moment/dist/locale/es'
import 'moment/dist/locale/fi'
import 'moment/dist/locale/fr'
import 'moment/dist/locale/it'
import 'moment/dist/locale/ja'
import 'moment/dist/locale/nl'
import 'moment/dist/locale/pt'
import 'moment/dist/locale/tr'

// defining a locale also selects it, so go back to the default until Store.configMoment picks one
moment.locale('en')
